import React from "react";
import Accordion from "react-bootstrap/Accordion";
import "../../../styles/pages-styles/main-dashboard-pages-styles/knowledge-pages-styles/KnowledgeSummary.css";
// import KnowledgeTable from "../../../components/knowledge-components/KnowledgeTable";
// import KnowledgeChart from "../../../components/knowledge-components/KnowledgeChart";
const columns = [
  "High-yield rating",
  "Attempted",
  "Total number of facts",
  "% attempted",
];
const data = [
  [
    { value: "A++, A+, A" },
    { value: "103" },
    { value: "1134" },
    { value: "9%" },
  ],
];

const data2 = [
  [{ value: "A++" }, { value: "57" }, { value: "378" }, { value: "15%" }],
  [{ value: "A+" }, { value: "28" }, { value: "378" }, { value: "7%" }],
  [{ value: "A" }, { value: "18" }, { value: "378" }, { value: "5%" }],
  [{ value: "B" }, { value: "10" }, { value: "378" }, { value: "3%" }],
  [{ value: "C" }, { value: "6" }, { value: "373" }, { value: "2%" }],
];

const KnowledgeSummary = () => {
  return (
    <div className="knowledge-summary">
      <div className="knowledge-summary-header">
        <h4>Knowledge tutor performance summary</h4>
        <p>
          The tables and chart below show you your performance in the knowledge
          tutor.
        </p>
      </div>

      <div className="knowledge-summary-body">
        <div className="knowledge-summary-table">
          <h5>Number of facts tested</h5>
          <p>So far, you've been tested on 119 out of 1885 facts.</p>
          {/* <KnowledgeTable columns={columns} data={data} /> */}
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                Show a more detailed breakdown
              </Accordion.Header>
              <Accordion.Body>
                {/* <KnowledgeTable columns={columns} data={data2} /> */}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>

        <div className="knowledge-summary-table">
          <h5>Performance in facts</h5>
          <p>The table below shows a breakdown of these 119 facts:</p>
          {/* <KnowledgeTable columns={columns} data={data} /> */}
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                Show a more detailed breakdown
              </Accordion.Header>
              <Accordion.Body>
                {/* <KnowledgeTable columns={columns} data={data2} /> */}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>

        <div className="knowledge-summary-table">
          <h5>Performance in facts</h5>
          {/* <KnowledgeChart /> */}
        </div>
      </div>
    </div>
  );
};

export default KnowledgeSummary;
